import * as React from 'react';

function SvgCycle(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 489.533 489.533"
      {...props}
    >
      <path d="M20.372 163.877C57.055 72.124 153.636 17.096 251.284 32.376 378.978 52.3 457.851 177.543 425.98 298.523l55.532 15.296c3.085.85 3.662 5.158 1.017 7.23L367.06 412.26a3.65 3.65 0 01-5.688-1.566l-52.478-137.472c-1.21-3.134 1.587-6.513 4.575-5.69l55.436 15.27c21.993-85.116-31.427-172.851-119.21-190.808C174.202 76.49 97.392 120.368 72.246 193.206c-26.656 77.193 11.052 159.46 81.994 191.862 13.176 6.015 19.883 20.828 16.059 34.711-4.753 17.258-23.8 26.533-40.121 19.133C29.038 393.005-23.407 273.487 20.372 163.877z" />
    </svg>
  );
}

export default SvgCycle;
